var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneRingRoundLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 13.3334L16.5918 16.777C17.0102 17.0908 17.5999 17.0292 17.9443 16.6355L26.667 6.66675",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16C28 18.5073 27.2146 20.9517 25.7542 22.9897C24.2937 25.0278 22.2315 26.5572 19.8573 27.3632C17.483 28.1691 14.9159 28.2111 12.5166 27.4833C10.1172 26.7554 8.00612 25.2943 6.47976 23.3051C4.9534 21.3159 4.08846 18.8986 4.00642 16.3926C3.92439 13.8867 4.62937 11.4179 6.02236 9.33316C7.41536 7.2484 9.42638 5.65233 11.773 4.76913C14.1196 3.88592 16.6839 3.75995 19.1058 4.40889",
    stroke: "#222222",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneRingRoundLight);
export default __webpack_public_path__ + "static/media/Done_ring_round_light.8a2b7bfec0d1322c023c3a6df6d3bfd7.svg";
export { ForwardRef as ReactComponent };